<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="关键词" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="关键词"
        prop="keyword"
        align="center">
      </el-table-column>
      <el-table-column
        label="是否热门"
        align="center">
        <template scope="scope">
            <div>{{isHot[scope.row.is_hot]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="是否默认"
        align="center">
        <template scope="scope">
            <div>{{isDefault[scope.row.is_default]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="排序"
        prop="sort_order"
        align="center">
      </el-table-column>
      <el-table-column
        label="链接"
        prop="scheme_url"
        align="center">
      </el-table-column>
      <el-table-column
        label="平台"
        align="center">
        <template scope="scope">
            <div>{{channel[scope.row.channel]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteDate(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="addForm.keyword" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="scheme_url">
          <el-input v-model="addForm.scheme_url" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否热门" prop="is_hot">
          <el-switch
            v-model="addForm.is_hot"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default">
          <el-switch
            v-model="addForm.is_default"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="平台" prop="channel">
          <el-select v-model="addForm.channel" placeholder="请选择">
            <el-option
              v-for="(item, index) in channel"
              :key="index"
              :label="channel[index]"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input v-model="addForm.sort_order" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="200px" :rules="formRules" ref="editForm">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="editForm.keyword" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="scheme_url">
          <el-input v-model="editForm.scheme_url" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否热门" prop="is_hot">
          <el-switch
            v-model="editForm.is_hot"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default">
          <el-switch
            v-model="editForm.is_default"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="平台" prop="channel">
          <el-select v-model="editForm.channel" placeholder="请选择">
            <el-option
              v-for="(item, index) in channel"
              :key="index"
              :label="channel[index]"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input v-model="editForm.sort_order" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          keyword: '',
          is_hot: '0',
          is_default: '0',
          sort_order: '',
          scheme_url: '',
          channel: '0',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        isHot: basicdata.isHot,
        isDefault: basicdata.isDefault,
        channel: basicdata.userChannel,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/keyword/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              para.sort_order = parseInt(para.sort_order);
              para.is_hot = parseInt(para.is_hot);
              para.is_default = parseInt(para.is_default);
              para.channel = parseInt(para.channel);
              //异步请求
              this.$axios.post(config.api_url + '/keyword',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              para.sort_order = parseInt(para.sort_order);
              para.is_hot = parseInt(para.is_hot);
              para.is_default = parseInt(para.is_default);
              para.channel = parseInt(para.channel);
              //异步请求
              this.$axios.put(config.api_url + '/keyword',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteDate(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/keyword/' + id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.is_hot = row.is_hot.toString();
        this.editForm.is_default = row.is_default.toString();
        this.editForm.channel = row.channel.toString();
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// keywords.vue?6cedecfc